import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import { Stack, ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { defaultTheme } from './theme';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import routes from './routes';
import React from 'react';
import UserProvider from '@authentication/contexts/userContext';
import PrivateRoute from '@atoms/PrivateRoute';
import PublicRoute from '@atoms/PublicRoute';
import Header from '@authentication/components/Header';
import CandidateProvider from '@authentication/contexts/candidateContext';
import useFFmpegStore from './store/ffmpg.store';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

function App(): JSX.Element {
  window.addEventListener('popstate', () => {
    history.pushState({}, '', '/');
  });
  const { loadFFmpeg } = useFFmpegStore();

  React.useEffect(() => {
    // Load FFmpeg on component mount
    loadFFmpeg();
  }, [loadFFmpeg]);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={defaultTheme}>
        <CssBaseline />
        <Stack direction="row">
          <Router>
            <Stack flex={1}>
              <UserProvider>
                <CandidateProvider>
                  <Routes>
                    {routes.map((route) => (
                      <Route
                        key={route.path}
                        path={route.path}
                        element={
                          route.private ? (
                            <PrivateRoute>
                              {route.showHeader && <Header />} {route.component}
                            </PrivateRoute>
                          ) : (
                            <PublicRoute>{route.component}</PublicRoute>
                          )
                        }
                      />
                    ))}
                    <Route path="*" element={<Navigate to="/" />} />
                  </Routes>
                </CandidateProvider>
              </UserProvider>
            </Stack>
          </Router>
        </Stack>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
